import React from "react";
import { CleanPerks } from "interfaces/api/apiInterfaces";
import {
    DiversityInclusion,
    Finance,
    HealthWellness,
    OfficeLife,
    ParentalBenefits,
    ProfessionalDevelopment,
    VacationTimeoff,
    WorkFlexibility
} from "components/Icons";

import styles from "./Perks.module.scss";

interface PerksProps {
    perksAndBenefits: CleanPerks;
}

/**
 * Returns the corresponding SVG icon based on the value of the `icon` parameter.
 */
const chooseIcon = (icon: string) => {
    switch (icon) {
    case "diversity_and_inclusion":
        return (<DiversityInclusion />);
    case "finance":
        return (<Finance />);
    case "health_and_wellness":
        return (<HealthWellness />);
    case "office_life":
        return (<OfficeLife />);
    case "parental_benefits":
        return (<ParentalBenefits />);
    case "professional_development":
        return (<ProfessionalDevelopment />);
    case "vacation_and_timeoff":
        return (<VacationTimeoff />);
    case "work_flexibility":
        return (<WorkFlexibility />);
    default:
        return null;
    }
};

/**
 * Renders a list of perks from the string array.
 */
const PerkList = (props: { list: string[]; }) => {
    const { list } = props;
    return (
        <ul>
            {list.filter(Boolean).map((x: string) => (<li key={x}>{x}</li>))}
        </ul>
    );
};

/**
 * Render the Perks module.
 * * Includes a title
 * * Includes a sub title for each bucket
 * * includes a list of the perks in each bucket.
 */
const Perks = (props: PerksProps) => {
    const { perksAndBenefits = {} } = props;
    const categories = Object.keys(perksAndBenefits);
    if (!categories.length) return null;
    return (
        <div className={styles.perks}>
            <h3>Perks and Benefits</h3>
            {categories.map((x: string) => (
                <div className={styles.perk} key={perksAndBenefits[x].value}>
                    {chooseIcon(perksAndBenefits[x].value)}
                    <span>
                        <h4>{perksAndBenefits[x].name}</h4>
                        <PerkList list={perksAndBenefits[x].perks} />
                    </span>
                </div>
            ))}
        </div>
    );
};
Perks.displayName = "Perks";

export { Perks };
